import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { createPartAction } from '../../../redux/actions/partsActions';
import Button from '../../shared/buttons/Button';
import Modal from '../../shared/modal/Modal';
import PartForm from '../forms/PartForm';

const CreatePartModal = ({ onModalClose, onModalSubmit }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const onSubmit = async (data) => {
    setLoading(true);
    await dispatch(createPartAction(data));
    setLoading(false);
    onModalSubmit();
  };

  return (
    <Modal
      title={'Додати деталь'}
      loading={loading}
      onClose={onModalClose}
      body={<PartForm readOnly={false} onSubmit={onSubmit} loading={loading} />}
      actionButton={
        <Button type={'submit'} disabled={loading} variant={'primary'} formId={'part-form'} children={'Зберегти'} />
      }
    />
  );
};

export default CreatePartModal;
